import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class OrdersProvidersInfo extends CommonCRUD {}

export default OrdersProvidersInfo;
